/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled      from 'styled-components';
import { Spacing } from '../../../styles/variables';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledInlineMessage = styled.p`
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 0 ${ Spacing.Tiny };
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledInlineMessage/index.js